import * as React from "react";
const SvgFiRrSolarPanel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-solar-panel_svg__a)">
      <path
        fill="#062147"
        d="m23.981 12.366-1.02-8A5.01 5.01 0 0 0 18 0H6.021a5.01 5.01 0 0 0-4.959 4.366l-1.022 8A5 5 0 0 0 5.001 18h6v4h-4a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-4v-4h6.022a4.998 4.998 0 0 0 4.958-5.634M20.976 4.62 21.408 8H16.44l-.375-6h1.936a3.005 3.005 0 0 1 2.975 2.62M9.064 16l.375-6h5.121l.375 6zm.5-8 .375-6h4.121l.375 6zM6.022 2h1.913L7.56 8H2.615l.432-3.38A3.006 3.006 0 0 1 6.022 2M2.75 14.982a3 3 0 0 1-.725-2.362L2.36 10h5.076l-.375 6H5a3 3 0 0 1-2.25-1.018m18.524 0A3 3 0 0 1 19.023 16h-2.084l-.375-6h5.1l.334 2.62a3 3 0 0 1-.725 2.362"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-solar-panel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSolarPanel;
